import React from 'react';
import { useIntl } from 'react-intl';
import PopoverContainer, { RenderOpenProps } from 'carbon-react/lib/components/popover-container';
import classNames from 'classnames';

import { useModal } from '@futrli/shared-services';

import * as styles from './popover-menu.scss';

export interface PopoverMenuItem {
  label: React.ReactNode;
  onClick: () => void;
  variant?: 'default' | 'danger';
  hasBorder?: boolean;
}

interface PopoverMenuProps {
  items: PopoverMenuItem[];
  renderOpenComponent: (props: RenderOpenProps) => JSX.Element;
  containerAriaLabel?: string;
}

export const PopoverMenu = ({ items, renderOpenComponent, containerAriaLabel }: PopoverMenuProps) => {
  const intl = useIntl();
  const { isOpen, open, close } = useModal();
  const ariaLabel = containerAriaLabel ?? intl.formatMessage({ id: 'common.menu', defaultMessage: 'Menu' });

  return (
    <PopoverContainer
      p={0}
      open={isOpen}
      onOpen={open}
      onClose={close}
      position="left"
      containerAriaLabel={ariaLabel}
      renderOpenComponent={renderOpenComponent}
      renderCloseComponent={() => <></>}
    >
      <div className={styles.popoverMenu} id="popover-menu">
        {items.map((item, index) => (
          <div
            key={index}
            className={classNames({
              [styles.popoverMenuItemDanger]: item.variant === 'danger',
              [styles.popoverMenuItem]: item.variant !== 'danger',
              [styles.popoverMenuItemBorder]: item.hasBorder
            })}
            onClick={() => {
              item.onClick();
              close();
            }}
            role="button"
            tabIndex={0}
          >
            {item.label}
          </div>
        ))}
      </div>
    </PopoverContainer>
  );
};
